import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pages/natural-perfumery")({
  beforeLoad: () => {
    throw redirect({ to: "/about", statusCode: 301 });
  },
});
